<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div style="gap: 12px;" class="col-12 col-sm-6 col-md-8 col-lg-8 d-flex align-items-center">
            <i class="fa ri-question-answer-fill" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
            <h4>
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <b-button class="right-align-sm mt-2 mt-sm-0" variant="primary" @click="appAdd()">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <!-- Backend Search -->
              <b-col class="col-12 col-sm-12 col-md-12 col-lg-8 mb-3">
                <input class="form-control"
                  id="search"
                  v-model="whereFilter.search_param"
                  type="search"
                  @input="searchUserWithParams"
                  :placeholder="cvSearchText"
                />
              </b-col><!-- Backend Search -->
              <b-col class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3 float-right">
                <i v-if="quizObjList && quizObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv mr-2 Download_button" title="Download CSV" @click="backendCsvDownload"></i>
              </b-col><!-- Backend Search -->
            </b-row><!-- Backend csv download -->

            <b-row>
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.quiz_type" class="form-control"  style="text-transform: capitalize;" @change="setQuizTypeFilter()">
                  <option  v-for="(quiz_type, index) of QuizType" :key="(index+1)" :value="quiz_type" >
                    {{quiz_type}}
                  </option>
                </select>
              </b-col>
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.event_state" class="form-control" @change="setEventStateFilter()">
                  <option :value="99">All</option>
                  <option :value="0">Publish</option>
                  <option :value="2">Unpublish</option>
                  <option :value="1">Delete</option>
                </select>
              </b-col>
            </b-row>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <!-- User Id Input Modal for attempting the quiz -->
          <b-modal
            v-model="showAttemptingUserIdModal"
            scrollable
            :title="cvAttemptingUserIdModalTitle"
            size="lg"
          >
            <div class="col-md-12 mb-3">
              <label for="validationslot_duration">{{ cvAttemptingUserIdLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
              <input v-model="attemptingUserId" type="text" class="form-control" required/>
            </div>

            <div class="col-md-12 mb-3">
              <label>Answer Mode</label>&nbsp;<label class="primary-color font-size-16">*</label>
              <b-form-radio-group
                v-model="attemptQuizAnswerMode"
                :options="attemptQuizAnswerModeOptions"
                stacked
              />
            </div>

            <button type="button" class="btn btn-primary ml-1" @click="attemptQuizForTesting()">{{ "Attempt Quiz" }}</button>

            <template #modal-footer="">
              <b-button size="sm" @click="emitCloseAttemptingUserIdModal()">
                {{cvbtnModalCancel}}
              </b-button>
            </template>
          </b-modal><!-- User Id Input Modal for attempting the quiz -->

          <b-col class="container_minheight" md="12" v-if="quizObjList && quizObjList.length > 0" :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="quizObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(app_name)="data">
                {{data.item.app_name}}<br>
                <small class="text-nowrap">Id:&nbsp;{{ data?.item?.app_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy( data?.item?.app_id)"></i></small><br>
                <b-button variant="mr-1 mb-1 " @click="openApp(data.item)" title="View App"><i class="fa fa-eye font-size-20" aria-hidden="true" ></i></b-button>
                <b-button variant="mr-1 mb-1 " @click="openAppv1(data.item)" title="View App"><i style="color: #324dc7;" class="fa fa-play font-size-20" aria-hidden="true" ></i></b-button>
                <AppResultSyncModal :propAppData="data.item"/>
                <b-button variant=" mr-1 mb-1 " @click="quizBankList(data.item)" title="Question Bank" v-if="!data.item.editable"><i class="fa fa-file-text-o font-size-20"></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="appResultList(data.item)" title="Results"><i class="fa fa-star font-size-20" aria-hidden="true"></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="appEdit(data.item)" title="App Edit" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20" title="Edit"></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="showQuizDeleteDialog(data.item)" title="Delete"><i class="ri-delete-bin-line m-0 font-size-20" title="Delete"></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="doCopy(data.item.app_id)" title="Copy App Id"><i class="fa fa-copy font-size-20" aria-hidden="true"></i></b-button>
                <b-button v-if="data.item.app_type == QuizType.COMPETITION" variant=" mr-1 mb-1 " @click="openEventDetail(data.item)" title="View Event Detail"><i class="fa fa-calendar font-size-20" aria-hidden="true" ></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="quizbankGenAnsExplanation(data.item)" title="Generate Answer Explanation via AI"><i class="fa fa-quora font-size-20" aria-hidden="true"></i></b-button>
                <b-button variant=" mr-1 mb-1 " @click="deleteQuizQuestions(data.item)" title="Delete Quiz Questions Before Re-upload"><i class="fa fa-ban font-size-20" aria-hidden="true"></i></b-button>
                <b-button variant=" mr-1 mb-1 " v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="openUserIdInputModel(data.item)" title="Attempt Quiz For Testing"><i class="fa fa-flask font-size-20" aria-hidden="true"></i></b-button>
                <b-button variant=" mr-1 mb-1 " v-if="userData.user_role == 'USERROLE11111'" @click="openUserTypeModel(data.item)" title="Change Quiz Type"><i class="fa-solid fa-bullhorn font-size-20" aria-hidden="true"></i></b-button>
                <b-button variant=" mr-1 mb-1 " v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" @click="quizQuestionAnalyse(data.item)" title="Analyze quiz questions"><i class="fa-solid fa-robot font-size-20" aria-hidden="true"></i></b-button>
                <b-button class="ml-2 actionIcon" size="sm" @click="duplicateApp('MODAL', data.item)"><i class="fa fa-files-o font-size-20" title="Duplicate quiz"></i></b-button>
                <b-button variant="mr-1 mb-1" @click="openAppChains(data.item)" title="App Chains"><i class="fa-solid fa-link m-0 font-size-20" title="App Chains"></i></b-button>
              </template>

              <template v-slot:cell(deleted)="data">
                <b-badge v-if="data.item.deleted === 0" class="pointer ml-1" variant="success mr-1 mb-1" size="sm" @click="openUrlInNew(data.item.event_weblink)">
                  Published&nbsp;
                </b-badge>
                <b-badge v-if="data.item.deleted === 2" class="pointer ml-1" variant="warning mr-1 mb-1" size="sm" @click="openUrlInNew(data.item.event_weblink)">
                  Unpublished
                </b-badge>
                <b-badge v-if="data.item.deleted === 1" class="pointer ml-1" variant="primary mr-1 mb-1" size="sm" @click="openUrlInNew(data.item.event_weblink)">
                  Deleted
                </b-badge>

                <b-button variant="light mr-1 mb-1" title="Unpublish"  :disabled="data.item.deleted === 2" @click="appPublishUnpublish(data.item, 2)">
                  <i class="fa fa-toggle-off m-0 font-size-20" style="color:red"></i>
                </b-button>
                <b-button variant="light mr-1 mb-1" title="Publish" :disabled="data.item.deleted === 0" @click="appPublishUnpublish(data.item, 0)">
                  <i class="fa fa-toggle-on m-0 font-size-20" style="color:green"></i>
                </b-button>
              </template>

              <template v-slot:cell(app_date_ts)="data">
                {{data.item.app_date_ts | dateFormat}}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="7" md="8" class="my-1">
              <b-btn class="mb-2" variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal v-model="showModelQuizDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelQuizDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="appDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <!--Change quiz type -->
    <b-modal
      v-model="showTypeModel"
      scrollable
      title="Select Type"
      size="xxl"
      hide-footer
    >
      <div class="col-md-12 mb-3">
        <label>{{ selectTypeLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
        <select id="changeQuizType" v-model="quizDetails.app_type" class="form-control">
          <option disabled :value="null">Select type</option>
          <option :value="appType" v-for="(i, appType) in this.QuizType" :key="appType">{{i}}</option>
        </select>
      </div>
      <div class="mt-4">
        <b-btn type="button" variant="primary" class="pull-left" @click="updateQizeType(quizDetails)">
          {{cvAddAppType}}
        </b-btn>
      </div>
    </b-modal><!--Change quiz type -->

    <!-- App Add Modal -->
    <b-modal
      v-model="showModelQuizAdd"
      scrollable
      :title="cvAddAppModalHeader"
      size="xxl"
    >
      <AppAdd :propOpenedInModal="true" :propDuplicateObj="addDuplicateObj" @emitCloseQuizAddModal="closeQuizAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="appAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeQuizAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- App Add Modal -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { Apps } from "../../../FackApi/api/apps.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import QuizType from "../../../FackApi/json/QuizType.js"
import userPermission from "../../../Utils/user_permission.js"
import { socialvue } from "../../../config/pluginInit"
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import AppAdd from "../Apps/AppAdd.vue"
import Utility from "../../../Utils/utility.js"
import AppResultSyncModal from "./AppResultSyncModal.vue"

export default {
  name: "AppList",
  components: {
    AppAdd,
    AppResultSyncModal
  },
  data () {
    return {
      apiName: "app_list_console",
      csvTitle: "app_list",
      cvCardTitle: "Apps - Quiz, Competition, Games",
      cvbtnAddNew: "Add",
      cvSearchText: "Type To Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are You Sure?",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "App List Response",
      showModelQuizDelete: false,
      showChangeAppidModal: false,
      sortBy: "name",
      sortDesc: false,
      QuizType: QuizType,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Name", key: "app_name", class: "text-left align-text-top w-350px font-weight-bold", sortable: true },
        { label: "App alias name", key: "app_name_alias", class: "text-left align-text-top", sortable: true },
        { label: "Status ", key: "deleted", class: "text-left align-text-top", sortable: true },
        { label: "Type", key: "app_type", class: "text-left align-text-top", sortable: true },
        { label: "Category", key: "app_category", class: "text-left align-text-top", sortable: true },
        { label: "Date", key: "app_date_ts", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Duration (Sec)", key: "app_duration", class: "text-left align-text-top", sortable: true },
        { label: "Is Gideplus?", key: "app_is_gideplus", class: "text-left align-text-top", sortable: true },
        { label: "Total Questions", key: "app_total_questions", class: "text-left align-text-top", sortable: true },
        { label: "Is Paid", key: "app_is_paid", class: "text-left align-text-top", sortable: true }
      ],
      quizObjList: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentBatchNo: 1,
      dataPerPage: 50,
      delObj: null,
      whereFilter: {
        search_param: "",
        quiz_type: "QUIZ",
        event_state: 99 // All Apps
      },
      showAttemptingUserIdModal: false,
      showLoadMoreBtn: false,
      cvAttemptingUserIdModalTitle: "Enter the user_id of the user for which the quiz has to be attempted",
      attemptingUserId: null,
      cvAttemptingUserIdLabel: "User Id",
      attemptQuizAppId: null,
      attemptQuizAnswerMode: "RANDOM",
      attemptQuizAnswerModeOptions: [
        { text: "All Correct", value: "ALL_CORRECT" },
        { text: "All Wrong", value: "ALL_WRONG" },
        { text: "All Skipped", value: "ALL_SKIPPED" },
        { text: "All Random Answer", value: "RANDOM" }
      ],
      selectTypeLabel: "Select Lable",
      showTypeModel: false,
      cvAddAppType: "Save",
      quizDetails: {},
      quizTypeappTypeList: {},
      showModelQuizAdd: false,
      cvAddAppModalHeader: "Add Quiz",
      addDuplicateObj: null,
      doCopy: Utility.doCopy,
      VUE_APP_TRUSTED_EMAILS: process.env.VUE_APP_TRUSTED_EMAILS,
      VUE_APP_ENV: process.env.VUE_APP_ENV
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    eventState () {
      return this.$store.getters["EventState/selectedEventState"]
    },
    quizType () {
      return this.$store.getters["QuizType/selectedQuizTypeState"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.getFiltersFromCache()
    this.QuizType = QuizType(this.userData.user_role)
    this.appList()
  },
  methods: {
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.appList(true)
    },
    /**
    * get data from store cache by this method
    */
    async getFiltersFromCache () {
      await this.getEventStateFilter()
      await this.getQuizTypeFilter()
    },
    /**
     * openApp
     */
    openApp (app) {
      window.open(`/quiz_detail/${app.app_id}`)
    },
    openAppv1 (app) {
      window.open(`/assessment/quizv1/${app.app_id}`)
    },
    /**
     * openAppChains
     */
    openAppChains (app) {
      window.open(`/app_chains/${app.app_id}`, "_blank")
    },
    /**
     * openEventDetail
     */
    openEventDetail (app) {
      window.open((`/event/${app.app_id}`), "_blank")
    },
    /**
     * Calling Function as per whereFilter
     */
    async setEventStateFilter () {
      this.$store.commit("EventState/addEventState", this.whereFilter.event_state)
      this.appList()
    },
    /**
     * Get Event State Filter
     * Upcoming, Past
     */
    async getEventStateFilter () {
      let EventState = await this.eventState
      if (EventState) {
        this.whereFilter.event_state = EventState
      }
      else if (EventState === 0) {
        this.whereFilter.event_state = EventState
      }
    },
    /**
     * Get Event State Filter
     * Upcoming, Past
     */
    async getQuizTypeFilter () {
      let QuizType = await this.quizType
      if (QuizType) {
        this.whereFilter.quiz_type = QuizType
      }
    },
    /**
     * Calling Function as per whereFilter
     */
    async setQuizTypeFilter () {
      this.$store.commit("QuizType/addQuizType", this.whereFilter.quiz_type)
      this.appList()
    },
    /**
     * quizBankList
     */
    async quizBankList (exam) {
      // this.$router.push(`/quizBank_list/${exam.app_id}`)
      window.open(`/quizBank_list/${exam.app_id}`, "_blank")
    },
    /**
     * appResultList
     */
    appResultList (app) {
      window.open(`/appResult_list/${app.app_id}`)
    },
    /**
     * searchUserWithParams
     */
    async searchUserWithParams () {
      if (this.whereFilter.search_param.length <= 3) {
        return
      }

      this.currentBatchNo = 1
      await this.appList()
    },
    /**
      * appList
      */
    async appList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage

        this.whereFilter.downloadCsv = downloadCsv

        let quizListResp = await Apps.appListConsole(this, this.whereFilter)
        if (quizListResp.resp_status) {
          if (downloadCsv) {
            window.open(quizListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.quizObjList = [...quizListResp.resp_data.data]
          }
          else {
            this.quizObjList = [ ...this.quizObjList, ...quizListResp.resp_data.data ]
          }
          this.totalRows = this.quizObjList.length
          this.showLoadMoreBtn = true
          this.quizObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.quizObjList.length
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = quizListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at appList() and Exception:", err.message)
      }
    },
    /**
     * appAdd
     */
    appAdd () {
      window.open("/app_add")
    },
    /**
     * appEdit
     */
    appEdit (quizEditObj) {
      window.open("/quiz_edit/" + quizEditObj.app_id)
    },
    /**
     * showQuizDeleteDialog
     */
    showQuizDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelQuizDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showQuizDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * appDelete
     */
    async appDelete () {
      try {
        let quizDelResp = await Apps.appDelete(this, this.delObj.app_id)
        await ApiResponse.responseMessageDisplay(this, quizDelResp)

        if (quizDelResp && !quizDelResp) {
          this.showModelQuizDelete = false
          return false
        }

        let index = this.quizObjList.indexOf(this.delObj)
        this.quizObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelQuizDelete = false
      }
      catch (err) {
        console.error("Exception occurred at appDelete() and Exception:", err.message)
      }
    },
    /**
     * emitCloseAttemptingUserIdModal
     */
    emitCloseAttemptingUserIdModal () {
      this.showAttemptingUserIdModal = false
    },
    /**
     * deleteQuizQuestions
     */
    async deleteQuizQuestions (appDetails) {
      try {
        const deleteObj = { app_id: appDetails.app_id, soft_delete: true }

        const bulDeleteResp = await QuizBanks.quizBankBulkDelete(this, deleteObj)
        ApiResponse.responseMessageDisplay(this, bulDeleteResp)
      }
      catch (err) {
        console.error("Exception in deleteQuizQuestions and err: ", err)
      }
    },
    /**
     * openUserIdInputModel
     */
    openUserIdInputModel (appDetails) {
      // Open the modal to input the user_id of the user whose attempt needs to be generated
      this.attemptQuizAppId = appDetails.app_id
      this.attemptingUserId = null
      this.attemptQuizAnswerMode = "RANDOM"
      this.showAttemptingUserIdModal = true
    },
    /**
     * attemptQuizForTesting
     */
    async attemptQuizForTesting () {
      try {
        const attempQuizObj = {
          user_id: this.userData.user_id,
          gide_user_id: this.attemptingUserId,
          app_id: this.attemptQuizAppId,
          answer_mode: this.attemptQuizAnswerMode
        }
        const attemptQuizResp = await QuizBanks.appsAutomaticResultGenerate(this, attempQuizObj)
        if (attemptQuizResp.resp_status) {
          this.showAttemptingUserIdModal = false
        }
        ApiResponse.responseMessageDisplay(this, attemptQuizResp)
      }
      catch (err) {
        console.error("Exception in attemptQuizForTesting and err: ", err)
      }
    },
    /**
     * closeQuizEditModal
     */
    closeQuizEditModal () {
      try {
        this.showModelQuizEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeQuizEditModal() and Exception:", err.message)
      }
    },
    /**
     * appPublishUnpublish
     */
    async appPublishUnpublish (data, targetState) {
      let payload = {
        app_id: data.app_id,
        deleted: targetState,
        image: data.app_image,
        desc: data.app_description,
        title: data.app_name,
        app_type: data.app_type,
        app_date_ts: data.app_date_ts,
        app_duration: data.app_duration
      }

      const questionResp = await Apps.appPublishUnpublish(this, payload)
      if (questionResp && questionResp.resp_status) {
        data.deleted = payload.deleted
      }
      else {
        ApiResponse.responseMessageDisplay(this, questionResp)
      }
    },
    /**
     * quizbankGenAnsExplanation
     */
    async quizbankGenAnsExplanation (appData) {
      try {
        const solveObj = {
          app_id: appData.app_id,
          app_category: appData.app_category,
          app_type: appData.app_type,
          app_total_questions: appData.app_total_questions
        }
        let quizSolveResp = await QuizBanks.quizBankSolve(this, solveObj)

        if (!quizSolveResp.resp_status) {
          this.toastMsg = quizSolveResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = quizSolveResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
      }
      catch (err) {
        console.error("Exception in quizbankGenAnsExplanation and err: ", err)
      }
    },
    /**
     * quizQuestionAnalyse
     */
    async quizQuestionAnalyse (appDetails) {
      try {
        const payload = {
          app_id: appDetails.app_id,
          user_email: this.userData.user_email
        }

        const analyseResp = await Apps.appQuizQuestionAnalyse(this, payload)
        ApiResponse.responseMessageDisplay(this, analyseResp)
      }
      catch (err) {
        console.error("Exception in quizQuestionAnalyse() and err: ", err.message)
      }
    },
    /**
     * openUserTypeModel
     */
    openUserTypeModel (qizeDetail) {
      this.quizDetails = qizeDetail
      this.showTypeModel = true
    },
    /**
     * updateQizeType
     */
    async updateQizeType (univObj) {
      try {
        const payload = {
          user_id: univObj.user_id,
          app_id: univObj.app_id,
          app_type: univObj.app_type
        }
        let quizAddResp = await Apps.appEdit(this, payload)
        if (quizAddResp.resp_status) {
          this.refreshExpandedUnivRecoList++
          this.showTypeModel = false
        }
      }
      catch (err) {
        console.error("Exception in editAdmission and err: ", err.message)
      }
    },
    /**
     * appAdd
     */
    duplicateApp (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/app_add")
        }
        else {
          this.addDuplicateObj = item
          this.showModelQuizAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at appAdd() and Exception:", err.message)
      }
    },
    /**
     * closeQuizAddModal
     */
    closeQuizAddModal () {
      try {
        this.showModelQuizAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closequizAddModal() and Exception:", err.message)
      }
    },
    /**
     * handleToast
     */
    handleToast (payload) {
      this.toastMsg = payload.toastMsg
      this.toastVariant = payload.toastVariant || "default"
      this.showToast = true
    },
    /**
     * backendCsvDownload
     */
    async backendCsvDownload () {
      this.appList(false, true)
      console.log("backendCsvDownload")
    },
    /**
     * goTo Quiz/App Attempt List
     */
    goToAttemptList (appId) {
      const query = {}

      if (this.$route.query.gide_user_id) {
        query.gide_user_id = this.$route.query.gide_user_id
      }

      if (appId) {
        this.$router.push({ path: `/attempt_list/${appId}/${appId}`, query })
      }
    }
  }
}
</script>
